<template>
    <div class="page" id="lesson">
        <header class="pageHeader rounded darken">
            <fade-image class="darken" src="assets/headers/lessons.png" />
        </header>

        <div class="scroller2 grey">
            <div v-if="!lesson">
                <pre-loader-item v-for="n in 5" :key="n" />
            </div>

            <div v-else>
                <header>
                    <h2>{{ $date(lesson.date).format("DD MMMM YYYY") }}</h2>
                    <ul class="links">
                        <li style="transform: translateY(-4px)">
                            <lesson-star :lesson="lesson" />
                        </li>
                        <li>
                            <a class="cancel" @click.prevent="$router.back()" href="#">
                                <x-icon class="icon" />
                            </a>
                        </li>
                    </ul>
                </header>

                <span v-if="lesson.title" class="info white">{{ lesson.title }}</span>

                <div v-for="(record, index) in lesson.record" :key="record.id">
                    <div class="recordText" v-if="record.type == 'text'">
                        {{ record.content }}
                    </div>

                    <single-image
                        class="thumbnail"
                        v-else-if="record.type == 'singleImage'"
                        :record="record"
                    />

                    <double-image
                        class="thumbnail"
                        v-else-if="record.type == 'doubleImage'"
                        :record="record"
                    />

                    <div v-else-if="record.type == 'video'" class="singleImage video">
                        <video controls>
                            <source
                                :src="imageURL(record.video_url) + '#t=0.001'"
                                type="video/mp4"
                            />
                        </video>
                    </div>

                    <!--<directional-graph :mainIndex="index" v-else-if="record.type == 'chart'" v-model="record.chart" :index="index" :editMode="false" :readonly="true"/>-->

                    <directional-graph2
                        :record="record"
                        :graphId="index"
                        v-else-if="record.type == 'chart'"
                        v-model="record.chart"
                        :index="index"
                        :editMode="false"
                        :readonly="true"
                    />

                    <putting-chart
                        :record="record"
                        :graphId="index"
                        v-else-if="record.type == 'putting_chart'"
                        v-model="record.chart"
                        :index="index"
                        :editMode="false"
                        :readonly="true"
                        :metric="record.metric"
                    />
                    <template v-if="index == 1 && record.is_player_submitted">
                        <div
                            class="recordText"
                            style="background: #f6d5a6"
                            v-if="lesson.player_video_lesson_note"
                        >
                            <strong style="margin-bottom: 5px">Player notes:</strong>
                            <p style="line-height: 22px">
                                {{ lesson.player_video_lesson_note }}
                            </p>
                        </div>
                    </template>
                </div>

                <div class="recordText" v-if="lesson.player_note">
                    {{ lesson.player_note }}
                </div>

                <div class="recordText" v-for="comment in lesson.comments" :key="comment.id">
                    {{ comment.content }}
                </div>
                <button
                    class="button dark left"
                    type="button"
                    name="button"
                    v-if="!commentOpen"
                    @click.prevent="commentOpen = true"
                >
                    Add comments
                    <img class="arrow" src="@/assets/arrow-right-white-2.svg" alt="" />
                </button>

                <form class="form3" v-else @submit.prevent="saveComment">
                    <div class="formGroup">
                        <textarea-autosize
                            placeholder="Type your message here"
                            v-model="form.content"
                            name="name"
                        />
                    </div>

                    <div class="formGroup" v-if="form.content">
                        <button :disabled="form.busy" class="button" type="submit" name="button">
                            {{ form.busy ? "Please wait..." : "Save comment" }}
                        </button>
                    </div>
                </form>

                <span class="info" v-if="!lesson.record" style="margin-top: 10px"
                    >You have no lesson history to view yet!<br />Come back and view the notes here
                    after your Pro has added them to your account.</span
                >
            </div>
            <!-- End else -->
        </div>
    </div>
</template>

<script>
import SingleImage from "@/views/Player/Lessons/partials/single-image";
import DoubleImage from "@/views/Player/Lessons/partials/double-image";
import { Form } from "vform";
import { XIcon } from "vue-feather-icons";
import FadeImage from "@/components/App/fade-image";
import PreLoaderItem from "@/components/App/Pre-loader-item";
import { imageURL } from "@/mixins/imageURL.js";
import LessonStar from "@/components/Player/Lessons/lesson-star";
import DirectionalGraph2 from "@/components/Pro/Lessons/content/directional-graph2";
import PuttingChart from "@/components/Pro/Lessons/content/putting-chart";
export default {
    name: "all-messages",
    mixins: [imageURL],
    components: {
        PuttingChart,
        DoubleImage,
        SingleImage,
        XIcon,
        DirectionalGraph2,
        FadeImage,
        PreLoaderItem,
        LessonStar,
    },
    created() {
        this.getLesson();
    },
    data() {
        return {
            lesson: false,
            commentOpen: false,
            form: new Form({
                content: "",
            }),
        };
    },
    methods: {
        getLesson() {
            window.axios.get("/lesson/" + this.$route.params.id).then((lesson) => {
                this.lesson = lesson.data;
            });
        },
        saveComment() {
            this.form.post("/lesson/" + this.$route.params.id + "/comment").then(() => {
                this.$notify("Comment added");
                this.getLesson();
                this.commentOpen = false;
                this.form.content = "";
            });
        },
    },
};
</script>

<style lang="scss" scoped>
#lesson {
    h2 {
        .star {
            float: right;
        }
    }
    video {
        width: 100% !important;
        border-radius: $radius;
        vertical-align: top;
    }
    .singleImage.video {
        min-height: auto !important;
        margin-bottom: 10px;
        background: #257961;
        border-radius: $radius;
    }
    .halfImage {
        width: calc(50% - 10px);
        margin-bottom: 20px;
        height: 200px;
        background-size: cover;
        border-radius: $radius;
        display: inline-block;
        &:first-of-type {
            margin-right: 20px;
        }
    }

    .recordText {
        background: white;
        padding: 20px;
        border-radius: $radius;
        margin-bottom: 10px;
        color: $green_0;
        white-space: pre-line;
        line-height: 1.5;
    }
    .thumbnail {
        max-width: 100%;
        margin-bottom: 10px;
        border-radius: $radius;
    }

    .info {
        font-size: 16px;
        margin-bottom: 10px;
        strong {
            font-weight: bold;
        }
    }
}
</style>
